var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCaretIcon = function SvgCaretIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -4 11 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.43 7.999L.827 13.436a1.476 1.476 0 000 2.125 1.58 1.58 0 002.188 0l7.053-6.851a.982.982 0 000-1.422L3.016.438A1.596 1.596 0 001.922 0 1.57 1.57 0 00.828.437a1.476 1.476 0 000 2.125L6.43 8z"
  })));
};
export default SvgCaretIcon;